import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

const cyPrefix = 'containers_bank_account_container';

const ids = addCyPrefixToIDs(cyPrefix, {
  BANK_ACCOUNT: 'BANK_ACCOUNT',
  INPUT_CURRENCY: 'INPUT_CURRENCY',
  INPUT_COUNTRY: 'INPUT_COUNTRY',
  INPUT_ACCOUNT_NUMBER: 'INPUT_ACCOUNT_NUMBER',
  INPUT_ACCOUNT_HOLDER: 'INPUT_ACCOUNT_HOLDER',
  INPUT_ROUTING_NUMBER: 'INPUT_ROUTING_NUMBER',
  INPUT_CA_TRANSIT_NUMBER: 'INPUT_CA_TRANSIT_NUMBER',
  INPUT_CA_INSTITUTION_NUMBER: 'INPUT_CA_INSTITUTION_NUMBER',
  INPUT_BIC: 'INPUT_BIC',
  INPUT_USE_AS_DEFAULT: 'INPUT_USE_AS_DEFAULT',
  BTN_ADD_BANK_ACCOUNT: 'BTN_ADD_BANK_ACCOUNT',
  BTN_SUBMIT: 'BTN_SUBMIT',
  ELEMENT_ROBOT_HELPER: 'ELEMENT_ROBOT_HELPER',
});

/**
 * We are exporting the IDS this way to help IDEs' code completion
 */
export const CY_BANK_ACCOUNT_CONTAINER_IDS = ids;
